"use client";

import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { API_BASE_URL ,USE_BACKEND} from "@/app/api/variable";
import axios from "axios";
import { About, Service } from "@/app/shared/type";
import servicesData from "@/app/data/service.json";
import aboutData from "@/app/data/about.json";
interface DataContextType {
  services: Service[];
  about: About | null;
  loading: boolean;
}

const DataContext = createContext<DataContextType | undefined>(undefined);

interface DataProviderProps {
  children: ReactNode;
}

export default function DataProvider({ children }: DataProviderProps) {
  const [services, setServices] = useState<Service[]>([]);
  const [about, setAbout] = useState<About | null>(null);
  const [loading, setLoading] = useState(true);

  // const fetchData = async () => {
  //   try {
  //     const [servicesRes, aboutRes] = await Promise.all([
  //       axios.get(`${API_BASE_URL}/service`),
  //       axios.get(`${API_BASE_URL}/about`),
  //     ]);

  //     setServices(servicesRes.data);
  //     if (aboutRes.data.data?.length) {
  //       setAbout(aboutRes.data.data[0]);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching data:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchData = async () => {
    try {
      if(USE_BACKEND){
      const servicesRes = await axios.get<Service[]>(`${API_BASE_URL}/service`);
      setServices(servicesRes.data);
      const aboutRes = await axios.get<{ data: About[] }>(`${API_BASE_URL}/about`);
      if (aboutRes.data?.data?.length) {
        setAbout(aboutRes.data.data[0]);
      } else {
        setAbout(null);
      }
    }else{
      setServices(servicesData as Service[]);
      setAbout(aboutData[0] as About);
    }
    } catch (err) {
      console.error("Error fetching data:", err);
      setServices([]);
      setAbout(null);
    } finally {
      setLoading(false);
    }
  };
  
  

  useEffect(() => {
    fetchData();
  }, []);

  const value = {
    services,
    about,
    loading
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
}

export function useData() {
  const context = useContext(DataContext);
  if (!context) {
    return {
      services: [],
      about: null,
      loading: true,
    };
  }
  return context;
}
